
  import { mapGetters } from 'vuex'
  import { ValidationProvider, ValidationObserver , extend } from 'vee-validate'
    import { required, regex, min, confirmed } from 'vee-validate/dist/rules';
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
const countries = require('i18n-iso-countries')
countries.registerLocale(require('i18n-iso-countries/langs/en.json'))
extend('required', {...required, message:'This field is required'})
extend('regexCapital', {...regex, message:'Must include a capital letter'})
extend('regexLower', {...regex, message:'Must include a lowercase letter'})
extend('regexNumber', {...regex, message:'Must include a number'})
extend('regexSpecial', {...regex, message:'Must include a special character (e.g. !-#)'})
extend('minimum', {...min, message:'Minimum 8 characters'})
extend('confirmed', {...confirmed, message:'Passwords must match'})

export default {
  components: {
    ValidationProvider,
    ValidationObserver,

  },
  props: {
    ischeckout: {
      type: String,
      default: 'true'
    },
  },



  data(){
      return {
        user:{username:'', password:'', password2: '', country:'GB'},
        showLoginForm: this.ischeckout !== 'true',
        showRegisterForm: this.ischeckout === 'true',
        showPasswordForm:false,
        showPasswordResetForm:false,
        showPasswordRequestConfirmation:false,
        showPasswordResetConfirmation:false,
        token:'',
        selectedCountry: 'GB',
        loggingIn: false,
        registering: false,
        error:{status:false,message:''},
        passwordText: {one: 'show', two: 'show'},
        passwordType: {one: 'password', two: 'password'},
        a: Math.ceil(Math.random() * 10),
        b: Math.ceil(Math.random() * 10),
        answer: null,
      }
  },
  computed: {
    ...mapGetters({
      // region: 'user/region',
      detectedCountry: 'geolocation/detectedCountry',
      regionClicked : 'cart/getRegionClicked'
    }),
    countries () {
      const list = countries.getNames('en', { select: 'official' })
      return Object.keys(list).map((key) => ({ value: key, label: list[key] }))
    },
    checkout() {
      const url = new URL(window.location).pathname
      console.log('URL: ',url);
      return url === '/checkout/'
    },
    bottest() {
      return `What is ${this.a} + ${this.b} ?`
    },
    c() {
      return parseInt(this.a + this.b)
    },
  },
  mounted() {
    this.user.country = this.detectedCountry
    // Add class to body so we can hide menu etc...
    // document.body.classList.add('fullscreen')

    if(this.$route.query.token){
      this.token = this.$route.query.token
      this.showLoginForm = false
      this.showPasswordResetForm = true
    }
    if(this.$route.query.reset){
      this.showLoginForm = false
      this.showPasswordForm = true
    }

  },
  methods:{
    async login(lms){
    this.loggingIn = true
    this.error.status = false;
      const _user = await this.$store.dispatch('user/login', this.user)
      console.log('USER: ',_user)
      if(_user.user_id){
        console.log('Logged in ok: ',_user,this.user)
        console.log('Checkout?  ',this.checkout)
        // identify user
        // if(process.client && window.rudderanalytics.ready && process.rudderLoaded){
          // Identify via rudderstack
          this.$rs.identify(this.user.username,{
            userId: _user.user_id,
            email: this.user.username,
          }, {
            integrations: {
              "Klaviyo": false,
            },
          })
          // Track via rudderstack
          this.$rs.track("Login Completed",{
            username: this.user.username
          }, {
            integrations: {
              "Klaviyo": false,
            },
          })
          // Track via GTM
          this.$gtm.push({
            event: 'login',
            method : 'email',
            user_id: String(_user.user_id),
						crm_id: String(_user.user_id),
            email: this.user.username,
          });
        // }


        // If we have an order we need to assign it
        if(this.orderId !== null){
          const _cart = await this.$store.dispatch('cart/assignCartServer')
          console.log('Assigned order ok: ',_cart)
        }

        if(lms){
          await this.lmsLogin();
        } else if(this.checkout) {
          this.loggingIn = false
          this.registering = false
          console.log('Rerouting to checkout...')
          this.$router.push('/checkout/')
        } else {
          this.loggingIn = false
          this.registering = false
          console.log('Rerouting to NEW dashboard...')
          if(this.$route.query?.newdash){
            window.location.href="https://account.tefl.org" // https://account.tefl.org
          }
          else{
          this.$router.push('/my-account/dashboard/')
          }
        }

      }else{
        this.loggingIn = false
        this.registering = false
        console.log('login error ' + _user)
        // TEST ERROR LOGGING HERE
        const errorData = await this.$store.dispatch('user/logError', "Log in error: "+_user)
        // const noteData = await this.$store.dispatch('user/addNote', {note: 'The was an error logging in: '+_user+'.'})
        console.log('Logged error ok: ',errorData)
        this.error.status = true
        this.error.message = _user
      }
    },

    async lmsLogin(){
    this.error.status = false;
      const _lmsUser = await this.$store.dispatch('user/lmsLogin', { ...this.user, source: 'login form' })
      console.log('LMS USER: ',_lmsUser)
      if(_lmsUser.session){
        this.loggingIn = false
        this.registering = false
        console.log('LMS logged in ok')
        console.log('Checkout?  ',this.checkout)
        if(this.checkout) {
          console.log('Rerouting to checkout...')
          this.$router.push('/checkout/')
        } else {
          console.log('Rerouting to NEWER dashboard...',this.$route.query,typeof this.$route.query?.newdash)
          if(this.$route.query?.newdash){
            console.log('Rerouting to NEWER dashboard...')
            window.location.href="https://account.tefl.org"

          }
          else{
          this.$router.push('/my-account/dashboard/')
          }

        }
      }else{
        this.loggingIn = false
        this.registering = false
        console.log('LMS login error', _lmsUser)
        console.log('Checkout?  ',this.checkout)
        // this.error.status = true
        // this.error.message = _lmsUser.error_message
        if(this.checkout) {
          console.log('Rerouting to checkout...')
          this.$router.push('/checkout/')
        } else {
          console.log('Rerouting to checkout...')
          if(this.$route.query?.newdash){
            console.log('Rerouting to NEWER dashboard...')
            window.location.href="https://account.tefl.org"

          }
          else{
          this.$router.push('/my-account/dashboard/')
          }
        }
      }
    },

    async register(){
      this.registering = true
      this.error.status = false;
      const _register = await this.$store.dispatch('user/register', this.user)
      console.log('REGISTER RESULT: ',_register)
      console.log('REGISTER STATUS: ',_register.status);
      if(_register.id){
        console.log('Register OK, logging in...')
        // this.$router.push('/my-account/dashboard/')
        // identify user
        if(window){
          // Track via rudderstack
          this.$rs.identify(this.user.username,{
            userId: _register.id,
            email: this.user.username,
          }, {
            integrations: {
              "Klaviyo": false,
            },
          })

          // Track via rudderstack
          /*
          this.$rs.track("User Sign Up Completed", {
            username: this.user.username
          })
          */
          // Track via GTM
          this.$gtm.push({
            event: 'sign_up',
            method : 'email',
            user_id: String(_register.id),
						crm_id: String(_register.id),
            email: this.user.username,
          });
        }
        this.login(false);
      }else{
        this.registering = false
        console.log('registration error: ' + _register)
        // TEST ERROR LOGGING HERE
        const errorData = await this.$store.dispatch('user/logError', "Registration error: "+_register)
        // const noteData = await this.$store.dispatch('user/addNote', {note: 'The was an error registering: '+_register+'.'})
        console.log('Logged error ok: ',errorData)
        this.error.status = true
        this.error.message = _register
      }
    },

    async requestResetPassword(){
      console.log('requesting password reset')
      const _request = await this.$store.dispatch('user/requestResetPassword', this.user)
      console.log('REQUEST RESULT: ',_request)
      // console.log('REQUEST STATUS: ',_request.status);
      if(_request.data){
        console.log(_request)
      this.showPasswordForm = false
      this.showPasswordRequestConfirmation = true
      // this.showPasswordResetForm = true
      }else{
        console.log('request error: ' + _request)
        this.error.status = true
        this.error.message = _request
      }
    },


    async resetPassword() {
      console.log('resetting password')
      const data = {
        token:this.token,
        password:this.user.password
      }
      const _reset = await this.$store.dispatch('user/resetPassword', data)
      console.log('RESET RESULT: ', _reset)

      if(_reset.data){
        this.showPasswordResetConfirmation = true
        this.showPasswordResetForm = false
        setTimeout(this.showLogin, 2500)

      } else{
        console.log('request error: ' + _reset)
        this.error.status = true
        this.error.message = _reset
      }
      // need to send id(from query param) or email here too
    },

    showLogin(){
      this.user = {username:'', password:''};
      this.error = {status:false,message:''};
      this.showLoginForm = true;
      this.showRegisterForm = false;
      this.showPasswordForm = false;
      this.showPasswordResetForm = false;
      this.showPasswordResetConfirmation = false
      this.passwordType.one = 'password'
      this.passwordText.one = 'show'
    },
    showRegister(){
      this.user = {username:'', password:'', password2: '', country:'GB'};
      this.error = {status:false,message:''};
      this.showRegisterForm = true;
      this.showLoginForm = false;
      this.showPasswordForm = false;
      this.passwordType.one = 'password'
      this.passwordText.one = 'show'
    },
    showRegister2(){
      this.user = {username:'', password:'', password2: '', country:'GB'};
      this.error = {status:false,message:''};
      this.showRegisterForm = true;
      this.showLoginForm = false;
      this.showPasswordForm = false;
      this.passwordType.two = 'password'
      this.passwordText.two = 'show'
    },

    showPassword(){
      this.user = {username:'', password:'', password2: ''};
      this.error = {status:false,message:''};
      this.showPasswordForm = true;
      this.showLoginForm = false;
      this.showRegisterForm = false;
      this.passwordType.one = 'password'
      this.passwordText.one = 'show'
    },
    showPassword2(){
      this.user = {username:'', password:'', password2: ''};
      this.error = {status:false,message:''};
      this.showPasswordForm = true;
      this.showLoginForm = false;
      this.showRegisterForm = false;
      this.passwordType.two = 'password'
      this.passwordText.two = 'show'
    },
    togglePassword(number){
      if (this.passwordType[number] === 'password') {
        this.passwordType[number] = 'text'
        this.passwordText[number] = 'hide'
      } else {
        this.passwordType[number] = 'password'
        this.passwordText[number] = 'show'
      }
    }
  }
}
